import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M8.13983 2.40639L4.78508 6.00077C4.48678 6.32038 4.71342 6.84193 5.15061 6.84193H11.6205C12.049 6.84193 12.2789 6.33825 11.9983 6.01446L8.88321 2.42009C8.68867 2.19562 8.3425 2.18925 8.13983 2.40639Z",
  fill: "#CCCCCC"
}), React.createElement("path", {
  d: "M8.57599 13.5687L11.9307 9.97433C12.229 9.65472 12.0024 9.13317 11.5652 9.13317L5.09533 9.13317C4.66687 9.13317 4.43687 9.63685 4.71749 9.96063L7.83261 13.555C8.02715 13.7795 8.37332 13.7859 8.57599 13.5687Z"
}), " "), "IconSortDesc");